import { render } from "./Projectes.vue?vue&type=template&id=a549eda2&scoped=true&ts=true"
import script from "./Projectes.vue?vue&type=script&lang=ts"
export * from "./Projectes.vue?vue&type=script&lang=ts"

import "./Projectes.vue?vue&type=style&index=0&id=a549eda2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a549eda2"]])

export default __exports__